import axios from '@/api/$axios'
export default {
  signature (data) {
    return axios.post(`/wechats/signature`, data)
  },
  setting (params) {
    return axios.get(`/wechats/setting`, { params })
  }
}
